<template>
  <DashboardPage>
    <CompanyCategory :id="route.params.id" />
  </DashboardPage>
</template>
  
<script setup>
import { useRoute } from 'vue-router';

import DashboardPage from '@/components/DashboardPage.vue';

import CompanyCategory from './components/CompanyCategory.vue';
const route = useRoute()
</script>